module.exports = __webpack_public_path__ + "static/img1_ats-bbbceea2cf9a888e4665ff0993178e79.png";